exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "homeTitle{\n\tfont-family: 'Marvel','sans-serif';\n\tfont-size:30px;\n\tline-height:1.3em;\n\tcolor: #444;\n}\n.rightTitle{\n\tfont-family: 'Marvel','sans-serif';\n\tfont-size:25px;\n\tline-height:1.3em;\n\tcolor: #444;\n}\n.homeChar{\n\tfont-family: 'Marvel','sans-serif';\n\tmargin-top:40px;\n\tmargin-bottom:30px;\n\t/*color: #444;*/\n\tfont-weight: bold;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/contact/contact.component.css
// module id = ../../../../../src/app/contact/contact.component.css
// module chunks = main